export default __webpack_public_path__ + "static/media/logo.171b7c08.jpg";